import React from 'react';
import PropTypes from 'prop-types';
import FooterWrapper, {
  MenuWrapper,
  CopyrightArea,
  SecondaryFooter,
  ContactArea,
  ContactAreaItem,
} from './Footer.style';

const Footer = ({ logo, menu, bgSrc, copyright, className, path }) => {
  return (
    <>
      <FooterWrapper id="footer" className={className} bg-img={bgSrc}>
        {logo && logo}
        {menu && <MenuWrapper>{menu}</MenuWrapper>}
        <ContactArea>
          <ContactAreaItem>
            Phone: <a href="tel:">+91 70196 20792</a> ,{' '}
            <a href="tel:">+91 88829 67672</a>
          </ContactAreaItem>
          <ContactAreaItem>
            Email:{' '}
            <a href="mailto:notifications@bidyourstay.com">
              notifications@bidyourstay.com
            </a>
          </ContactAreaItem>
        </ContactArea>
        {copyright && <CopyrightArea>{copyright}</CopyrightArea>}
      </FooterWrapper>
      {!!path && <SecondaryFooter />}
    </>
  );
};

Footer.propTypes = {
  className: PropTypes.string,
  logo: PropTypes.element,
  menu: PropTypes.element,
  bgSrc: PropTypes.string,
  copyright: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default Footer;
